import { Box } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/styles'
import { Maybe } from '@ts/operations'
import { DateTime } from 'luxon'
import React, { useEffect, useState } from 'react'

import { Theme } from '../../lib/theming/Theme'
import CountdownCardHolder from './CountdownCardHolder'
import CountdownHeading from './CountdownHeading'

const useStyles = makeStyles<Theme>(theme => ({
  countdown: {
    background: theme.palette.primary.main,
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
}))

const calculateCountdown = (endsAt: DateTime) => {
  const { days, hours, minutes, seconds } = endsAt.diff(DateTime.utc(), [
    'days',
    'hours',
    'minutes',
    'seconds',
  ])
  const timeLeft = {
    days,
    hours,
    minutes,
    seconds: Math.floor(seconds),
  }

  return timeLeft.seconds < 0 ? { days: 0, hours: 0, minutes: 0, seconds: 0 } : timeLeft
}

const Countdown = (props: { endsAt: DateTime; message: Maybe<string> }) => {
  const classes = useStyles()
  const { endsAt, message } = props
  const [countDown, setCountDown] = useState(calculateCountdown(endsAt))

  useEffect(() => {
    const interval = setInterval(() => {
      const timeLeft = calculateCountdown(endsAt)
      setCountDown(timeLeft)
    }, 1000)
    return () => clearInterval(interval)
  }, [endsAt])

  return (
    <div className={classes.countdown}>
      {message && <CountdownHeading message={message} />}
      <Box mb={1}>
        <Grid container justify="center" wrap="nowrap">
          <CountdownCardHolder unit="days" value={countDown.days} />
          <CountdownCardHolder unit="hours" value={countDown.hours} />
          <CountdownCardHolder unit="minutes" value={countDown.minutes} />
          <CountdownCardHolder unit="seconds" value={countDown.seconds} />
        </Grid>
      </Box>
    </div>
  )
}

export default Countdown
